import Vue from 'vue'
import Router from 'vue-router'

import { i18n } from '@/i18n'
import store from '@/store/store'

import LangPart from '@/components/LangPart'

import Home from '@/components/views/home'
import Productos from '@/components/views/productos'
import Product_details from '@/components/views/product-details'
import ProductosQuimicos from '@/components/views/productos-quimicos'
import Catalogo from '@/components/views/catalogo'
import Area_tecnica from '@/components/views/area-tecnica'
import Ajusa from '@/components/views/ajusa'
import HistoriaInfografia from '@/components/views/historia-infografia'

import Actualidad from '@/components/views/actualidad'
import Blog from '@/components/views/blog'
import Categoria_blog from '@/components/views/categoria-blog'
import Ficha_blog from '@/components/views/ficha-blog'
import SalaPrensa from '@/components/views/sala-prensa'

import Contacto from '@/components/views/contacto'
import TrabajaConNosotros from '@/components/views/trabaja-con-nosotros'

import PoliticaPrivacidad from '@/components/views/politica-privacidad'
import PoliticaCookies from '@/components/views/politica-cookies'
import DatosSeguros from '@/components/views/datos-seguros'
import AvisoLegal from '@/components/views/aviso-legal'
import VehiculoElectrico from '@/components/views/vehiculo-electrico'
import MapaWeb from '@/components/views/mapa-web'
import bonosAjusa from '@/components/views/bonos-ajusa';
import thankYouPage from '@/components/views/thank-you-page';
import Error404 from '@/components/views/error-404';

import messages from '@/translations';
import {
    FALLBACK_LANGUAGE,
    NOT_FOUND_ROUTE,
    applyCanonicalAndAlternates,
    applyOpenGraph,
    applyPrerenderStatus,
    applyRobots,
    buildPath,
    canonicalIdFor,
    clearCanonicalAndAlternates,
    getCanonicalKey,
    isTranslatedLanguage,
    setMetaContent,
} from '@/seo/head';
import { applyJsonLd } from '@/seo/jsonld';

Vue.use(Router);
let routes = [
    {
        path: '/:lang(es|en|ru|br|fr|us)?',
        name: "language-part",
        component: LangPart,
        children: [
            //STATIC
            {
                alias: `/home`,
                name: 'home',
                component: Home,
            },
            {
                name: 'sobre_nosotros',
                component: Ajusa,
            },
            {
                name: 'aniversario50',
                component: HistoriaInfografia
            },
            {
                name: 'mapa_web',
                component: MapaWeb,
            },
            {
                name: 'politica',
                component: PoliticaPrivacidad,
            },
            {
                name: 'politica_cookies',
                component: PoliticaCookies,
            },
            {
                name: 'aviso_legal',
                component: AvisoLegal,
            },
            {
                name: 'datos_seguros',
                component: DatosSeguros,
            },
            {
                name: 'vehiculo_electrico',
                component: VehiculoElectrico,
            },
            {
                name: 'area_tecnica',
                component: Area_tecnica,
                meta: {
                    idParameter: true,
                }
            },
            //PRODUCTS
            {
                name: 'productos',
                component: Productos,
                meta: {
                    idParameter: true,
                }
            },
            {
                name: 'product',
                component: Product_details,
                meta: {
                    idParameter: true
                }
            },
            {
                name: 'productos_quimicos',
                component: ProductosQuimicos,
            },
            //CATALOG
            {
                name: 'catalogo',
                component: Catalogo,
                meta: {
                    idParameter: true,
                }
            },
            {
                name: 'actualidad',
                component: Actualidad,
            },
            {
                name: 'blog',
                component: Blog,
            },
            {
                name: 'blog_noticia',
                component: Ficha_blog,
                meta: {
                    idParameter: true,
                }
            },
            {
                name: 'blog_categoria',
                component: Categoria_blog,
                meta: {
                    idParameter: true,
                }

            },
            //FORMS
            {
                name: 'contacto',
                component: Contacto,
                meta: {
                    idParameter: true,
                }
            },
            {
                name: 'sala_prensa',
                component: SalaPrensa,
            },
            {
                name: 'trabaja_con_nosotros',
                component: TrabajaConNosotros,
                meta: {
                    idParameter: true,
                }
            },
            {
                name: 'bonos_ajusa',
                component: bonosAjusa,
                idParameter: true,
            },
            //THANK YOU PAGE
            {
                name: 'newsletter_thank',
                component: thankYouPage,
            },
            // Comodin: cualquier URL que no corresponda a una pagina. Declara
            // su `path` explicitamente para que el forEach de abajo no intente
            // resolverlo desde `enlaces`, y va al final porque vue-router
            // resuelve por orden de declaracion.
            {
                path: '*',
                name: NOT_FOUND_ROUTE,
                component: Error404,
            },
        ]
    }
];

routes[0].children.forEach(function (value, key) {
    if (value.path == null) {
        value.path = i18n.t('enlaces.' + value.name);
        value.alias = [];
        value.meta = value.meta ? value.meta : {};
        value.meta.seo = value.meta.seo ? value.meta.seo : {};
        Object.keys(messages).forEach(function (lang) {
            if (value.meta.seo[lang] == null) {
                value.meta.seo[lang] = messages[lang].enlaces.seo[value.name];
            }
            if (
                messages[lang].enlaces[value.name] != null &&
                messages[lang].enlaces[value.name] != value.path &&
                value.alias.includes(messages[lang].enlaces[value.name]) == false
            ) {
                value.alias.push(messages[lang].enlaces[value.name]);
            }

        });
        if (value.meta.idParameter) {
            value.path += "/:id?";
            value.alias.forEach(function (alia, index) {
                value.alias[index] += "/:id?";
            });
        }
    }
});

const router = new Router({
    mode: 'history',
    routes: routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    },
});

router.beforeEach((to, from, next) => {
    to.meta.previousRoute = from.name;

    // URL que no corresponde a ninguna pagina. Se atiende aqui, antes de las
    // ramas de redireccion: no hay slug traducido al que redirigir -y hacerlo
    // seria cambiar una URL inexistente por otra-, asi que se conserva la URL,
    // se declara que no existe y se retiran las senales de la pagina anterior.
    if (to.name === NOT_FOUND_ROUTE) {
        const lang = isTranslatedLanguage(to.params.lang)
            ? to.params.lang
            : (store.getters.getLanguage || i18n.locale);

        if (lang !== store.getters.getLanguage) {
            store.dispatch('changeLanguage', lang);
        }

        applyRobots(to.name);
        applyPrerenderStatus(to.name);
        clearCanonicalAndAlternates();
        document.title = i18n.t('error_404.nombre');

        next();
        return;
    }

    if (to.params.lang == null) {
        to.params.lang = store.getters.getLanguage ? store.getters.getLanguage : i18n.locale;
        next({
            path: to.params.lang + "/" + i18n.t('enlaces.' + to.name),
            name: to.name ? to.name : "home",
            params: to.params,
        });
        return;
    }
    // El regex de :lang admite idiomas que no estan traducidos (hoy `ru`). Sin
    // esto la pagina se renderiza en ingles pero con la URL del idioma pedido y
    // sin metadatos, quedando indexable como duplicado. Se redirige al idioma de
    // respaldo para consolidar las senales en una sola URL.
    if (!isTranslatedLanguage(to.params.lang)) {
        // El id viene en un idioma sin datos: solo se conserva si el idioma de
        // respaldo lo reconoce; si no, se cae a la pagina sin id.
        let fallbackId = to.params.id;
        if (fallbackId && !getCanonicalKey(to.name, fallbackId, FALLBACK_LANGUAGE)) {
            fallbackId = null;
        }
        next(buildPath(FALLBACK_LANGUAGE, to.name || 'home', fallbackId) || '/' + FALLBACK_LANGUAGE + '/');
        return;
    }

    if (to.params.lang && to.params.lang != store.getters.getLanguage) {
        let lang = to.params.lang;
        store.dispatch('changeLanguage', lang);
    }

    let explode = to.path.split("/");

    if (to.name && to.name != "home" && explode.length > 2) {
        explode.shift();
        explode.shift();
        if (to.meta.idParameter && to.params.id) {
            explode.pop();
        }
        explode = explode.join("/");
        if (explode != i18n.t('enlaces.' + to.name)) {
            //Yeah...risky as hell
            let url = "/" + to.params.lang + "/" + i18n.t('enlaces.' + to.name);
            if (to.params.id) {
                url += "/" + to.params.id;
            }
            next(url);
            return;
        }
    }

    let meta = (to.meta.seo) ? to.meta.seo[to.params.lang] : null;

    // `noindex, follow` en las plantillas del blog. Va antes del resto para que
    // la etiqueta quede escrita (o retirada) en cada navegacion, tambien cuando
    // la pagina no tiene metadatos SEO y el bloque de abajo no se ejecuta.
    applyRobots(to.name);
    // Retira el `prerender-status-code` que hubiera dejado una 404 previa: sin
    // esto la pagina siguiente se serviria con codigo 404 a los buscadores.
    applyPrerenderStatus(to.name);

    // Canonical y hreflang se construyen desde (idioma, ruta, id), no desde
    // `location`: asi el canonical no arrastra parametros de tracking ni
    // fragmentos, y coincide exactamente con el hreflang propio de la pagina.
    // En `productos`, `catalogo` y `area_tecnica` el id es solo un ancla para
    // hacer scroll: no debe formar parte de ninguna senal de SEO, o la misma
    // pagina se declara varias veces con metadatos identicos.
    const seoId = canonicalIdFor(to.name, to.params.id);

    const canonicalUrl = applyCanonicalAndAlternates(to.name, to.params.lang, seoId);

    // Open Graph propio de cada pagina: imagen representativa, tipo e idioma.
    // Antes index.html declaraba una sola og:image generica para todo el sitio.
    applyOpenGraph(to.name, to.params.lang, seoId, {
        title: meta ? meta.title : null,
        description: meta ? meta.description : null,
        imageAlt: meta ? meta.title : null,
    });

    if (!!meta && !!meta.description) {
        document.title = meta.title
        setMetaContent("[property='og:title']", 'meta', { property: 'og:title' }, meta.title);
        setMetaContent('[name=description]', 'meta', { name: 'description' }, meta.description);
        setMetaContent("[property='og:description']", 'meta', { property: 'og:description' }, meta.description);
        setMetaContent("[property='og:url']", 'meta', { property: 'og:url' }, canonicalUrl);

        const keywordRoutes = ['home', 'productos', 'vehiculo_electrico'];
        const keyword = keywordRoutes.indexOf(to.name) !== -1 ? (meta.keyword || '') : '';
        setMetaContent('[name=keywords]', 'meta', { name: 'keywords' }, keyword);
    }

    // Datos estructurados: un unico <script type="application/ld+json"> que se
    // sobrescribe en cada navegacion.
    applyJsonLd(to.name, to.params.lang, seoId, meta);

    next()
});


export default router;


// WEBPACK FOOTER //
// ./src/router/index.js